module.exports = __webpack_public_path__ + "img/1531355052.d654a593.jpg";